document.addEventListener('DOMContentLoaded', (event) => {
    var uspSwipes = new Swiper('.cuf .usp__block.swiper-container', {
        loop: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        // autoplay: {
        //     delay: 1000,
        // },
    });
});